export const NETTO = 'NETTO';
export const NETTODIFF = 'NETTODIFF';
export const PROSENT = 'PROSENT';
export const DEBIT = 'Debet';
export const KREDIT = 'Kredit';
export const PLUSS_DEBIT = '+Debet';
export const PLUSS_KREDIT = '+Kredit';
export const $OPPGJDATO = '$OPPGJDATO';
export const $REISEDATO = '$REISEDATO';
export const $CLEARINGDATE = '$CLEARINGDATE';
export const $MAPPING_PERIODIZED_CLEARING = '$MAPPING_PERIODIZED_CLEARING';
export const INCOMINGSETTLEMENTEXPANDEDROW = 'incomingSettlementExpandedRow';
export const NEXT = 'next';
export const PREVIOUS = 'previous';
export const DEFAULTCHARTOFACCOUNTS = 'defaultChartOfAccounts';
